import React from "react";
import moment from "moment";
import { object, string } from "yup";
import { Form, Formik, FormikHelpers, FormikProps } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/redux/store";
import ExpenseListFilterDialog from "./ExpenseListFilterDialog";
import { setDateFilter } from "src/redux/slices/ExpensesSlice";

type Props = {
  open: boolean;
  onClose: () => void;
};

export type FormInitialValues = {
  startDate: string | null;
  endDate: string | null;
};

const ExpenseListFilterWrapperDialog = ({ open, onClose }: Props) => {
  const dispatch = useDispatch<AppDispatch>();

  const { dateFilter }: any = useSelector((state: RootState) => state.expenses);

  // Initial Values
  const initialValues: FormInitialValues = {
    startDate: dateFilter.start_date
      ? dateFilter.start_date
      : moment().startOf("month").format("YYYY-MM-DD"),
    endDate: dateFilter.end_date
      ? dateFilter.end_date
      : moment().endOf("month").format("YYYY-MM-DD"),
  };

  const validationSchema: any = object({
    startDate: string().required("please select start date"),
    endDate: string().required("please select end date"),
  });

  // Submit Handler
  const handleSubmit = async (
    values: FormInitialValues,
    { setSubmitting }: FormikHelpers<FormInitialValues>
  ) => {
    setSubmitting(false);
    dispatch(
      setDateFilter({
        start_date: values.startDate
          ? moment(values.startDate)?.format("yyyy-MM-DD")
          : "",
        end_date: values.endDate
          ? moment(values.endDate)?.format("yyyy-MM-DD")
          : "",
      })
    );
    onClose();
  };

  // Reset Handler
  const handleReset = async (formikProps: FormikProps<FormInitialValues>) => {
    await dispatch(
      setDateFilter({
        start_date: "",
        end_date: "",
      })
    );
    formikProps.resetForm();
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form>
          <ExpenseListFilterDialog
            open={open}
            onClose={onClose}
            formikProps={formikProps}
            onReset={() => handleReset(formikProps)}
          />
        </Form>
      )}
    </Formik>
  );
};

export default ExpenseListFilterWrapperDialog;
